export default __webpack_public_path__ + "static/media/player-full.6d557402.jpg";